import script from "./ListPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPagination.vue?vue&type=script&setup=true&lang=js"

import "./ListPagination.vue?vue&type=style&index=0&id=59be75e6&lang=scss"

const __exports__ = script;

export default __exports__